// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__E5yfT","info":"Pagination_info__yOXmB","button":"Pagination_button__SBNk4"};